const Thanks = () => {
  return <div className="col-12 d-flex flex-column justify-content-center align-items-center" style={{ height: "100vh" }}>
    <div className="fs-1 greyBlueText">תודה, תשובתכם עודכנה</div>
    <img src='./assets/icons/check.svg' height="300" width="300"/>
  </div>;
};

export default Thanks;
